var exports = {
  "jy": "AnimationTab.module__radioSection___TWhNX2",
  "lm": "AnimationTab.module__radioHeader___TWhNX2",
  "et": "AnimationTab.module__radioLabel___TWhNX2",
  "Ye": "AnimationTab.module__radioDescription___TWhNX2",
  "X0": "AnimationTab.module__reducedMotionNote___TWhNX2",
};

module.exports = exports;
